import localForage from "localforage";

localForage.config({
  name: "uploadQueue",
  storeName: "videos",
});

export const saveBlob = async (key: string, blob: Blob) => {
  await localForage.setItem(key, blob);
};

export const getBlob = async (key: string): Promise<Blob | null> => {
  return (await localForage.getItem<Blob>(key)) || null;
};

export const removeBlob = async (key: string) => {
  await localForage.removeItem(key);
};
